import { useEffect, RefObject } from 'react';

/**
 * Hook pour gérer le clic en dehors d'un élément
 * @param ref - Référence à l'élément HTML
 * @param callback - Fonction à appeler quand on clique en dehors
 * @param enabled - Si false, l'event listener ne sera pas ajouté (par défaut: true)
 */
export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
  enabled: boolean = true
): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, enabled]);
};

